"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var defaultStyles = {
  width: "100%",
  display: "block",
  position: "relative",
  borderRadius: "4px",
  marginBottom: "10px",
  border: "1px solid #ccc"
};

exports.default = function (_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? "" : _ref$className,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === undefined ? "#fff" : _ref$bgColor,
      _ref$fontColor = _ref.fontColor,
      fontColor = _ref$fontColor === undefined ? "#000" : _ref$fontColor,
      style = _ref.style,
      children = _ref.children;

  var styles = _extends({}, defaultStyles, style, {
    backgroundColor: bgColor,
    color: fontColor
  });

  return _react2.default.createElement("div", {
    className: "card " + className,
    style: styles
  }, children);
};